import { Icon } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import styles from './DocumentRequirement.module.css';

const Required = () => {
  return (
    <span className={styles.required}>
      <Icon
        className={styles.requiredIcon}
        icon="exclamationTriangleFilled"
        height={20}
        width={20}
      />
      <Trans>Required</Trans>
    </span>
  );
};

export default Required;
